export type AvulsoRetentionSheet = "validation" | "beforeLeave" | "tag" | null;

export type AvulsoRetentionAction =
  | "deny"
  | "payNow"
  | "dismissBeforeLeave"
  | "dismissTag"
  | "contractTag";

export interface AvulsoRetentionStep {
  sheet: AvulsoRetentionSheet;
  exit: boolean;
}

const RETENTION_STEPS: Record<AvulsoRetentionAction, AvulsoRetentionStep> = {
  deny: { sheet: "beforeLeave", exit: false },
  payNow: { sheet: "validation", exit: false },
  dismissBeforeLeave: { sheet: "tag", exit: false },
  dismissTag: { sheet: null, exit: true },
  contractTag: { sheet: "tag", exit: false },
};

/* Fluxo de retenção da gaveta de validação avulsa:
   Não → Antes de sair → (Pagar agora → gaveta | Agora não → oferta da tag → sair) */
export function resolveAvulsoRetentionStep(
  action: AvulsoRetentionAction,
): AvulsoRetentionStep {
  return RETENTION_STEPS[action];
}
